import React from 'react';
import CustomDeletePage from 'components/custom-pages/CustomDelete';

const Delete = ({ data, handleClick }) => {
  return (
    <CustomDeletePage
      pageTitle={'Delete Inspectoin Actionable'}
      url={'inspection-actionable'}
      queryKey="inspection-actionable"
      title={'Inspectoin Actionable'}
      id={data?._id}
      handleClick={handleClick}
    />
  );
};

export default Delete;
